import {
  SEASON_WATER_MULTIPLIER,
  TERRAIN_BASE_WATER,
} from "../../models/config/balance.ts";
import type { Season } from "../../models/season.ts";
import type { TileTerrain } from "../../models/worldState.ts";

/** Display-only water amount for a tile from terrain and season. */
export function getWaterAmount(terrain: TileTerrain, season: Season): number {
  return Math.round(TERRAIN_BASE_WATER[terrain] * SEASON_WATER_MULTIPLIER[season]);
}

export function formatWaterAmount(terrain: TileTerrain, season: Season): string {
  return String(getWaterAmount(terrain, season));
}
